import Dialog from '@/components/Dialog';
import { useReportingToolsStore } from '../../store/useReportingToolsStore';

function DialogComponent() {
  const openDialog = useReportingToolsStore((state) => state.openDialog);
  const dialogData = useReportingToolsStore((state) => state.dialogData);

  return (
    <Dialog
      open={openDialog}
      setOpen={() => useReportingToolsStore.setState({ openDialog: false })}
      title={dialogData.title}
      body={
        <>
          <p
            className="arrow-scope quote-scope scope-text-sh-xs text-left font-cadiz text-sh-xs"
            dangerouslySetInnerHTML={{
              __html: dialogData.description,
            }}></p>
        </>
      }
    />
  );
}

export default DialogComponent;
